(function () {
  var KEY = "wt-lang-suggest-dismissed";
  function stored() { try { return localStorage.getItem(KEY) === "1"; } catch (e) { return false; } }
  function remember() { try { localStorage.setItem(KEY, "1"); } catch (e) {} }
  if (stored()) return;

  var pageLang = (document.documentElement.getAttribute("lang") || "ja").toLowerCase();
  function fam(s) {
    s = (s || "").toLowerCase();
    if (s.indexOf("ja") === 0) return "ja";
    if (s.indexOf("ko") === 0) return "ko";
    if (s.indexOf("zh") === 0) {
      if (s.indexOf("tw") >= 0 || s.indexOf("hk") >= 0 || s.indexOf("hant") >= 0) return "zh";
      return "zh";
    }
    if (s.indexOf("en") === 0) return "en";
    return "other";
  }
  var here = fam(pageLang);
  var langs = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language];
  var want = "other";
  for (var i = 0; i < langs.length; i++) { var f = fam(langs[i]); if (f !== "other") { want = f; break; } }
  if (!want || want === "other") want = "en";
  if (want === here) return;

  var PREFIX = { ja: "", en: "/en", "zh": "/zh-CN", ko: "/ko" };
  var COPY = {
    en: { msg: "This store is also available in English.", go: "View in English" },
    zh: { msg: "本店也提供简体中文版本。", go: "查看中文版" },
    ko: { msg: "본 스토어는 한국어로도 보실 수 있습니다.", go: "한국어로 보기" },
    ja: { msg: "日本語でご覧いただけます。", go: "日本語で見る" }
  };
  var c = COPY[want];
  if (!c) return;

  var path = location.pathname.replace(/^\/(en|ko|zh-CN|zh-Hans)(?=\/|$)/i, "") || "/";
  var target = (PREFIX[want] || "") + path + location.search + location.hash;

  function build() {
    if (document.getElementById("wt-lang-bar")) return;
    var st = document.createElement("style");
    st.textContent =
      "#wt-lang-bar{position:fixed;left:0;right:0;bottom:0;z-index:2147483000;background:#12302C;color:#F4F1E8;" +
      "font-family:'Hiragino Mincho ProN','Yu Mincho','Noto Serif JP',serif;font-size:14px;line-height:1.6;" +
      "padding:14px 18px;display:flex;align-items:center;justify-content:center;gap:16px;flex-wrap:wrap;" +
      "box-shadow:0 -6px 24px rgba(0,0,0,.18);transform:translateY(110%);transition:transform .45s ease}" +
      "#wt-lang-bar.wt-in{transform:none}" +
      "#wt-lang-bar .wt-go{display:inline-block;border:1px solid #C4A864;color:#C4A864;text-decoration:none;" +
      "padding:7px 18px;border-radius:999px;font-size:13px;letter-spacing:.04em;white-space:nowrap}" +
      "#wt-lang-bar .wt-go:hover{background:#C4A864;color:#12302C}" +
      "#wt-lang-bar .wt-x{position:absolute;right:12px;top:50%;transform:translateY(-50%);background:none;border:0;" +
      "color:rgba(244,241,232,.55);font-size:22px;line-height:1;cursor:pointer;padding:4px 8px}" +
      "@media (max-width:520px){#wt-lang-bar{font-size:13px;padding:13px 34px 13px 14px;gap:10px}}";
    document.head.appendChild(st);

    var bar = document.createElement("div");
    bar.id = "wt-lang-bar";
    var span = document.createElement("span");
    span.textContent = c.msg;
    var a = document.createElement("a");
    a.className = "wt-go";
    a.href = target;
    a.textContent = c.go;
    a.addEventListener("click", remember);
    var x = document.createElement("button");
    x.className = "wt-x";
    x.type = "button";
    x.setAttribute("aria-label", "close");
    x.innerHTML = "&times;";
    x.addEventListener("click", function () { remember(); bar.parentNode && bar.parentNode.removeChild(bar); });
    bar.appendChild(span); bar.appendChild(a); bar.appendChild(x);
    document.body.appendChild(bar);
    setTimeout(function () { bar.className = "wt-in"; }, 700);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", build);
  else build();
})();
